import PropTypes from 'prop-types';

import { Heading } from '@spotahome/ui-library';

const SectionHeading = props => (
  <Heading
    size={props.size}
    text={props.text}
    className="mb-xl"
    level={props.level}
    theme={props.theme}
    type={props.type}
    align={props.align}
  />
);

SectionHeading.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  level: PropTypes.number,
  theme: PropTypes.string,
  type: PropTypes.string,
  align: PropTypes.string
};

SectionHeading.defaultProps = {
  size: 'large',
  level: 2,
  theme: 'dark',
  type: 'uppercase',
  align: 'center'
};

export default SectionHeading;
